import { useMemo, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import equal from "fast-deep-equal";
import { useAsyncAction, useAsyncActionState } from "../async-actions/hooks.js";
import "../async-actions/actions.js";
import "../../intl/shared-resources/serverResponse.js";
import "rxjs";
import "rxjs/operators";
import "typesafe-actions";
import "react-oidc-context";
import "react-router";
import "oidc-client-ts";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../async-action/action.js";
import "../error-handling/action.js";
import "../actions.js";
import "react-redux";
import "../async-actions/reducers.js";
const useReduxForm = ({
  initialModel,
  asyncAction,
  map,
  onSuccess,
  shouldResetOnError = true,
  mode,
  modelId,
  allowUnchangedModelSubmit = false
}) => {
  const { formatMessage } = useIntl();
  const { dispatchAction, resetActionState, idActionState, noIdActionState } = useAsyncAction({
    asyncAction,
    onSuccess: (actionId, successfulResponse) => onSuccess?.(form.getValues(), actionId, successfulResponse)
  });
  const state = useMemo(() => modelId ? idActionState[modelId] : noIdActionState, [idActionState, noIdActionState, modelId]);
  const form = useForm({
    defaultValues: initialModel,
    mode
  });
  useEffect(() => {
    form.reset(initialModel);
  }, [JSON.stringify(initialModel)]);
  useEffect(() => {
    if (state?.isError && shouldResetOnError) {
      form.reset(initialModel);
    }
  }, [state?.isError]);
  useEffect(() => {
    return () => {
      resetActionState(modelId);
    };
  }, []);
  const submit = (newModel) => {
    const initialValue = map(initialModel);
    const newValue = map(newModel);
    if (allowUnchangedModelSubmit || !equal(initialValue, newValue)) {
      dispatchAction(modelId, newValue);
    } else {
      cancel();
    }
  };
  const cancel = () => {
    form.reset(initialModel);
    resetActionState(modelId);
  };
  const formattedErrorMessage = state?.errorMessage ? formatMessage(state?.errorMessage, state?.errorMessageValues) : null;
  return {
    ...form,
    state: {
      ...state,
      resetAsyncActionState: () => resetActionState(modelId)
    },
    submit,
    cancel,
    formattedErrorMessage
  };
};
const useReduxFormRequestMode = (asyncAction, actionId, isMultiStep) => {
  const [requestMode, setRequestMode] = useState("Read");
  const state = useAsyncActionState(asyncAction, actionId);
  useEffect(() => {
    setRequestMode(state.isProgress ? "InProgress" : "Read");
  }, [state.isProgress]);
  useEffect(() => {
    if (state.errorMessage) {
      setRequestMode(isMultiStep ? "EditMultiStep" : "Edit");
    }
  }, [state.errorMessage]);
  useEffect(() => {
    return () => {
      state.resetAsyncActionState();
    };
  }, []);
  return { requestMode, resetRequestMode: state.resetAsyncActionState };
};
export {
  useReduxForm,
  useReduxFormRequestMode
};
//# sourceMappingURL=hooks.js.map
